import { render, staticRenderFns } from "./RelativeTimeOdds.vue?vue&type=template&id=464f8458"
import script from "./RelativeTimeOdds.vue?vue&type=script&lang=js"
export * from "./RelativeTimeOdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports